import React from 'react';

function Home() {
	return (
		<div className="home">
			<h2>Welcome!</h2>
			<p>
				Lorem ipsum dolor sit amet consectetur adipisicing elit. Odit harum
				perferendis cumque deserunt aspernatur veritatis incidunt, voluptatum
				blanditiis. Architecto reprehenderit quo tempore excepturi at eum, sunt
				eligendi ad non quae officia, sint optio inventore sit culpa. Porro rem
				dolorem omnis?
			</p>
			<p>
				Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolores vitae
				non possimus quisquam officia sunt? Omnis nihil earum labore rerum qui
				officiis maiores temporibus eaque minima, aspernatur aut quisquam autem
				debitis! Esse qui delectus distinctio ea ipsam eos tenetur nihil.
			</p>
			<p>
				Lorem ipsum dolor sit amet consectetur, adipisicing elit. Nam neque
				ducimus asperiores rerum ea veritatis aliquam corrupti tempore sed
				reiciendis maxime, provident assumenda autem similique est odio
				doloribus nostrum quae iste aspernatur placeat alias. Recusandae
				voluptatem totam in quisquam nostrum.
			</p>
		</div>
	);
}

export default Home;
